import { AgGridReact } from "ag-grid-react";
import { useRef } from "react";
import { ColDef, ICellRendererParams } from "ag-grid-community";
import AgGrid from "../../../UI/AgGrid";
import { useTranslation } from "react-i18next";
import CloseIcon from "@mui/icons-material/Close";
import { IconButton } from "@mui/material";
import { useDisable } from "../../../../hooks/use-disable";
import { IPromotion } from "../../../../types/Marketing/Promotion";
import { useFormContext, useWatch } from "react-hook-form";

type Props = {
  rowData: any[];
  onRemoveHandler: (index: number) => void;
};

const PromotionSelectSalesChannelTable = ({
  rowData,
  onRemoveHandler,
}: Props) => {
  const gridRef = useRef<AgGridReact>();
  const { t } = useTranslation();
  const [disabled] = useDisable();

  const { control } = useFormContext<IPromotion>();

  const watchIsApplied = useWatch({ control, name: "is_applied" });
  const isApplied = Boolean(watchIsApplied);

  const columnDefs: ColDef[] = [
    {
      field: "unique_id",
      headerName: t("setting.unique_id"),
      filter: "agTextColumnFilter",
      flex: 1,
      minWidth: 200,
    },
    {
      field: "name_th",
      headerName: t("setting.name_th"),
      filter: "agTextColumnFilter",
      flex: 1,
      minWidth: 200,
    },
    {
      field: "name_en",
      headerName: t("setting.name_en"),
      filter: "agTextColumnFilter",
      flex: 1,
      minWidth: 200,
    },
    {
      field: "description",
      headerName: t("setting.description"),
      filter: "agTextColumnFilter",
      flex: 1,
      minWidth: 200,
    },
    ...(disabled || isApplied
      ? []
      : [
          {
            field: "",
            filter: false,
            sortable: false,
            width: 50,
            cellStyle: {
              display: "flex",
              justifyContent: "center",
            },
            cellRenderer: (params: ICellRendererParams) => {
              if (params.data) {
                return (
                  <IconButton
                    onClick={() => onRemoveHandler(params.rowIndex)}
                    size="small"
                  >
                    <CloseIcon fontSize="small" />
                  </IconButton>
                );
              }
            },
          },
        ]),
  ];

  return (
    <AgGrid
      ref={gridRef}
      columnDefs={columnDefs}
      rowData={rowData}
      height={300}
    />
  );
};

export default PromotionSelectSalesChannelTable;
